import React from 'react';
import { Icon } from './Icon';

// MainPage Component - Simplified version that works with current props
const MainPage = ({
  currentUser,
  attendanceData,
  paymentData,
  newsData,
  schoolEvents,
  onTabChange,
  calculateAttendanceRate,
  getAttendanceStatus,
  formatCurrency,
  formatDate
}) => {
  // Defensive programming - ensure arrays exist before filtering
  const safeAttendanceData = Array.isArray(attendanceData) ? attendanceData : [];
  const safePaymentData = Array.isArray(paymentData) ? paymentData : [];
  const safeNewsData = Array.isArray(newsData) ? newsData : [];
  const safeSchoolEvents = Array.isArray(schoolEvents) ? schoolEvents : [];

  // Teacher-specific stats
  const stats = {
    classes: currentUser?.classes?.length || currentUser?.assigned_classes?.length || 0,
    students: currentUser?.total_students || currentUser?.student_count || 0,
    pendingGrading: currentUser?.pending_grading || currentUser?.pending_homework_grading || 0,
    pendingAttendance: currentUser?.pending_attendance || currentUser?.pending_attendance_marking || 0
  };

  // Get recent attendance data
  const recentAttendance = safeAttendanceData.slice(0, 5);
  
  // Get recent payment data
  const recentPayments = safePaymentData.slice(0, 5);
  
  // Get recent news
  const recentNews = safeNewsData.slice(0, 5);
  
  // Get upcoming events
  const upcomingEvents = safeSchoolEvents.slice(0, 3);

  return (
    <div style={{maxWidth: '1200px', margin: '0 auto'}}>
      {/* Header Section */}
      <div style={{marginBottom: '32px'}}>
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1f2937',
          marginBottom: '8px'
        }}>
          歡迎回來，{currentUser?.name || '老師'}
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          今天是 {new Date().toLocaleDateString('zh-TW')}，讓我們開始今天的工作
        </p>
      </div>

      {/* Teacher-specific Quick Stats */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#3b82f6',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>📚</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>我的班級</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {stats.classes}
              </div>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#10b981',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>👨‍🎓</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>學生總數</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {stats.students}
              </div>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#f59e0b',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>📝</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>待批改</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {stats.pendingGrading}
              </div>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#ef4444',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>📊</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>待考勤</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {stats.pendingAttendance}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Teacher Quick Actions */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '32px'
      }}>
        <button 
          onClick={() => onTabChange('homework')}
          style={{
            backgroundColor: '#10b981',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📝 建立家課
        </button>
        
        <button 
          onClick={() => onTabChange('attendance')}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📊 記錄考勤
        </button>
        
        <button 
          onClick={() => onTabChange('grades')}
          style={{
            backgroundColor: '#f59e0b',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📈 輸入成績
        </button>
        
        <button 
          onClick={() => onTabChange('classes')}
          style={{
            backgroundColor: '#8b5cf6',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📚 我的班級
        </button>
      </div>

      {/* Recent Activity */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        {/* Recent Attendance */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb',
          padding: '20px'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '16px'
          }}>
            最近考勤紀錄
          </h3>
          {recentAttendance.length > 0 ? (
            <div>
              {recentAttendance.map((record, index) => (
                <div key={index} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0',
                  borderBottom: index < recentAttendance.length - 1 ? '1px solid #e5e7eb' : 'none'
                }}>
                  <span style={{color: '#374151'}}>
                    {record.studentName || `學生${index + 1}`}
                  </span>
                  <span style={{
                    color: record.status === 'present' ? '#10b981' : '#ef4444',
                    fontWeight: '500'
                  }}>
                    {getAttendanceStatus ? getAttendanceStatus(record.status) : record.status}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p style={{color: '#6b7280', fontStyle: 'italic'}}>暫無考勤紀錄</p>
          )}
        </div>

        {/* Recent News */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb',
          padding: '20px'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '16px'
          }}>
            最新學校宣佈
          </h3>
          {recentNews.length > 0 ? (
            <div>
              {recentNews.map((news, index) => (
                <div key={index} style={{
                  padding: '8px 0',
                  borderBottom: index < recentNews.length - 1 ? '1px solid #e5e7eb' : 'none'
                }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#1f2937',
                    marginBottom: '4px'
                  }}>
                    {news.title || `公告${index + 1}`}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#6b7280'
                  }}>
                    {formatDate ? formatDate(news.date) : news.date}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{color: '#6b7280', fontStyle: 'italic'}}>暫無最新公告</p>
          )}
        </div>
      </div>

      {/* Upcoming Events */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e5e7eb',
        padding: '20px'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '16px'
        }}>
          即將舉行的活動
        </h3>
        {upcomingEvents.length > 0 ? (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '16px'
          }}>
            {upcomingEvents.map((event, index) => (
              <div key={index} style={{
                padding: '16px',
                backgroundColor: '#f9fafb',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
              }}>
                <div style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#1f2937',
                  marginBottom: '8px'
                }}>
                  {event.title || `活動${index + 1}`}
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  marginBottom: '4px'
                }}>
                  {formatDate ? formatDate(event.date) : event.date}
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#374151'
                }}>
                  {event.description || '活動描述'}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p style={{color: '#6b7280', fontStyle: 'italic'}}>暫無即將舉行的活動</p>
        )}
      </div>
    </div>
  );
};

export default MainPage;
